import { PassingBoardActionList, PassingBoardType } from "../actions/passingBoardActions";
import { Action } from "../actions/types";

const initialValue: Array<PassingBoardType> = [];

const passingBoardReducer = (state: Array<PassingBoardType> = initialValue, action: Action) => {
    switch (action.type) {
        case PassingBoardActionList.ADD_PASSING_BOARD:
            return [
                ...state,
                action.data,
            ];

        case PassingBoardActionList.UPDATE_PASSING_BOARD:
            const updated = [...state].slice();
            const index = updated.findIndex(u => u.id === action.data.id);

            if (index > -1) {
                updated[index] = {
                    ...action.data,
                };
            }

            return updated;

        case PassingBoardActionList.FETCH_PASSING_BOARD:
            return action.data;

        case PassingBoardActionList.DELETE_PASSING_BOARD:
            return state.filter(s => s.id !== action.data);

        default:
            return state;
    }
}

export default passingBoardReducer;
